var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseLayout',[_c('ProfileHeader'),_c('div',{staticClass:"profile-content common-wrapper"},[_c('div',{staticClass:"forms"},[_c('InfoForm'),_c('LocationForm'),_c('PasswordForm')],1),_c('div',{staticClass:"photo"},[_c('ProfileImageForm'),_c('LogoutButton')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }